export default __webpack_public_path__ + "static/media/text-underline.3d3df4ee.svg";